import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {TargetGroupSwitchView} from './TargetGroupSwitchView';
import {useRequestTargetGroups} from './useRequestDrawerNavigation';

export const TargetGroupSwitch = () => {
  return (
    <div data-testid="topCategorySwitchHeader">
      <DataFetcher
        request={useRequestTargetGroups()}
        Loading={Skeleton}
        Error={() => <div />}
        View={TargetGroupSwitchView}
      />
    </div>
  );
};

const Skeleton = () => {
  return (
    <>
      <SkeletonBlock $height="40px" disableSpaceBelow />
    </>
  );
};
